import { useEffect } from 'react';

const UseScrollReveal = (selector = '.reveal', offset = 50) => {
  useEffect(() => {
    const handleScroll = () => {
      const reveals = document.querySelectorAll(selector);

      for (let i = 0; i < reveals.length; i++) {
        const windowHeight = window.innerHeight;
        const elementTop = reveals[i].getBoundingClientRect().top;

        if (elementTop < windowHeight - offset) {
          reveals[i].classList.add('active');
        } else {
          reveals[i].classList.remove('active');
        }
      }
    };

    window.addEventListener('scroll', handleScroll);
    handleScroll(); // Trigger on mount
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [selector, offset]);
};

export default UseScrollReveal;
